import { useTranslation } from 'react-i18next'

const MumAfter = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      role="image"
      aria-labelledby="mum-after-title"
      viewBox="0 0 1920 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="mum-after-title">{t('antagonists:mum:components:end')}</title>
      <defs>
        <clipPath id="mum-b">
          <path
            d="M1586.24 984.55s1.42 11.93-13.35 14.06c-10.5 1.5-16.47-11.09-20.74-16.2-4.26-5.12-8.81-7.96-12.22-7.53-2.72.34-20.6 20.3-30.97 28.83-10.72 8.8-24.73 14.48-31.25 16.91-6.53 2.42-8.66 4.55-10.79 7.53s-2.13 15.48-2.13 15.48 5.53 3.69 13.77 4.97c8.24 1.28 18.61.57 24.47.32 14.22-.6 21.32-4.29 46.79-8.29 25.47-3.99 45.65-5.23 45.65-5.23s.72-8.11-.14-18.9c-.5-6.23-.5-10.72-2.27-19.46-1.77-8.73-3.56-12.34-6.81-12.49h-.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="mum-c">
          <path
            d="M1656.9 977.04c-7.86-2.37-17.32 7.6-20.72 12.03-3.41 4.45-9.62 15.85-14.36 27.4-4.74 11.55-6.96 14.36-6.96 14.36s-2.08 1.48-3.26 3.7c-1.19 2.23-2.82 16.3-.75 17.33 2.06 1.04 29.91 3.26 42.49 2.23 12.58-1.03 18.96-7.4 23.25-12.58s16.58-10.22 16.58-10.22-.45-17.63-3.56-30.36-6.81-17.91-6.81-17.91l.3 2.96c.29 2.96.29 9.32-2.23 9.47s-16.58-16.16-23.99-18.4h.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="mum-d">
          <path
            d="m1612.63 173.58-59.97 9.16s6.02 29.48 8.12 34.81c3.15 7.99 9.91 16.41-6.12 28.67-16.02 12.25-27.81 16.45-27.81 16.45l-2.82 33.94 140.92 8.02-.94-68.81s-35.36-9.44-46.2-24.51c-10.84-15.08-5.18-37.7-5.18-37.7Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="mum-e">
          <path
            d="M1602.36 217.22c8.43-9.12 13.38-10.38 20.81-27.32 6.29-14.33 4.75-26.83.62-40.65-2.35-7.87-7.4-9.27-7.4-9.27l-79.84 14.08s-.97 3.72-.25 12.77c1.27 15.88 3.03 24.94 15.08 37.01 5.4 5.4 16.57 14.53 27.95 18.67 4.82 1.75 17.93.22 23.02-5.28Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#f8f7f0}.h{fill:#eb6a36}.i{fill:#e9b926}.j{fill:#f1f1f3}.k{fill:#c4c7c9}.l{fill:#e2a972}.m{fill:#1c3628}.n{fill:#2e425b}.o{fill:#272a3e}.p{clip-path:url(#mum-c)}.q{clip-path:url(#mum-b)}.r{clip-path:url(#mum-e)}.s{clip-path:url(#mum-d)}'
          }
        </style>
      </defs>
      <path
        d="M1556.14 67.44c-36.65 8.11-53.84 53.54-47.26 83.24 6.58 29.7 14.78 74.43 14.78 74.43 73.73 11.8 119.48-24.73 119.64-24.68 1.16.36 3.01-46.56-5.49-80.62-8.95-35.88-41.38-61.3-81.65-52.39h-.01Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="m1582.29 628.33-86.47-2.8s-1.21 57.25-1.21 82.47 6.4 46.44 6.4 62.06 6.8 27.23 8.01 34.44c1.21 7.2 8.81 38.43 14.82 65.25 6 26.81 20.82 76.47 19.22 94.48-1.59 18.01-6.8 30.83-6.8 30.83l33.23 12.82 19.62-11.61s-1.28-16.87-2.45-37.23c-.75-13.02 6.94-91.25 2.54-121.68-4.41-30.43-16.91-47.29-22.51-62.1-5.61-14.81 15.61-146.93 15.61-146.93Z"
        style={{
          fill: '#e9b926',
        }}
      />
      <path
        d="M1586.24 984.55s1.42 11.93-13.35 14.06c-10.5 1.5-16.47-11.09-20.74-16.2-4.26-5.12-8.81-7.96-12.22-7.53-2.72.34-20.6 20.3-30.97 28.83-10.72 8.8-24.73 14.48-31.25 16.91-6.53 2.42-8.66 4.55-10.79 7.53s-2.13 15.48-2.13 15.48 5.53 3.69 13.77 4.97c8.24 1.28 18.61.57 24.47.32 14.22-.6 21.32-4.29 46.79-8.29 25.47-3.99 45.65-5.23 45.65-5.23s.72-8.11-.14-18.9c-.5-6.23-.5-10.72-2.27-19.46-1.77-8.73-3.56-12.34-6.81-12.49h-.01Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-b)',
        }}
      >
        <path
          d="m1605.99 1016.8.42 19.89s-125.98 21.59-126.55 21.59-19.6-12.93-19.6-12.93l7.67-23.87s2.7 2.41 6.68 4.4 18.32 4.69 36.08 2.27c17.76-2.42 46.31-6.96 58.24-8.53 11.93-1.57 37.07-2.85 37.07-2.85Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
      </g>
      <path
        d="m1678.3 641.46-70.28-.27s2.8 43.24 4.4 66.46c1.59 23.22 13.61 64.06 18.41 79.28 4.8 15.22 7.61 33.43 10.41 51.04 2.81 17.62 8.4 93.68 9.61 104.9 1.21 11.21.41 22.03-2.8 30.43-3.21 8.4-3.21 22.41-3.21 23.62s38.82 3.62 38.82 3.62-.65-27.32 2.72-38.96c5.16-17.83 18.7-56.38 18.61-95.82-.09-40.76-11.42-85.5-15.83-109.73-4.4-24.23-10.89-114.54-10.89-114.54h.01Z"
        style={{
          fill: '#e9b926',
        }}
      />
      <path
        d="M1656.9 977.04c-7.86-2.37-17.32 7.6-20.72 12.03-3.41 4.45-9.62 15.85-14.36 27.4-4.74 11.55-6.96 14.36-6.96 14.36s-2.08 1.48-3.26 3.7c-1.19 2.23-2.82 16.3-.75 17.33 2.06 1.04 29.91 3.26 42.49 2.23 12.58-1.03 18.96-7.4 23.25-12.58s16.58-10.22 16.58-10.22-.45-17.63-3.56-30.36-6.81-17.91-6.81-17.91l.3 2.96c.29 2.96.29 9.32-2.23 9.47s-16.58-16.16-23.99-18.4h.01Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-c)',
        }}
      >
        <path
          d="M1696.14 1008.52s9.95 11.65 9.52 11.65-22.15 48.87-22.02 49.58c.15.72-77.13-3.83-77.13-3.83s-3.27-29.98-3.27-29.55 9.09-5.11 9.09-5.11 7.67 1.85 15.91 1.99c8.24.14 23.3-.15 31.96-1.28s14.2-7.38 21.44-12.36c7.24-4.97 14.48-11.08 14.48-11.08Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
      </g>
      <path
        d="M1673.07 520.22 1502.5 452.7s-27.52 87.93-25.82 114.28c2.39 37.1 11.25 225.27 11.25 225.27s42.62 16.56 101.25 20.11c58.63 3.56 134.63-14.84 134.63-14.84s-27.22-133.14-29-182.89-21.76-94.43-21.76-94.43h.01Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1582.62 215.18c-33.47 2.36-52.32 24.51-57.51 39.12s0 49.49 0 49.49l153.18-20.74s.93-36.76-2.36-49.02c-3.29-12.25-7.53-19.32-24.97-19.79s-68.35.94-68.35.94h.01Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="m1612.63 173.58-59.97 9.16s6.02 29.48 8.12 34.81c3.15 7.99 9.91 16.41-6.12 28.67-16.02 12.25-27.81 16.45-27.81 16.45l-2.82 33.94 140.92 8.02-.94-68.81s-35.36-9.44-46.2-24.51c-10.84-15.08-5.18-37.7-5.18-37.7Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-d)',
        }}
      >
        <path
          d="m1664.02 229.03 5.98 4.79-14.36 100.53-108.91 43.09-51.47-116.1 26.33-14.36s55.05 9.57 67.02 8.38c11.96-1.19 75.4-26.33 75.4-26.33h.01Z"
          style={{
            fill: '#f8f7f0',
          }}
        />
      </g>
      <path
        d="M1703.85 247.41c-7.55-8.02-50.16-30.06-61.36-27.81-21.07 4.23-54.1 70.75-57.28 68.1-11-9.16-31.8-48.27-31.8-48.27s-43.45 18.82-56.65 35.79c-13.2 16.96-23.64 103.87-26.94 124.6-3.29 20.74-16.5 72.12-8.95 78.24 7.55 6.12 18.63 12.87 18.63 12.87l-16.27 79.98s32.99 12.26 94.27 24.04c61.26 11.79 145.36-5.31 145.36-5.31s-1.62-18.41-3.98-35.85-6.53-33.13-6.53-33.13 23.97-16.3 39.31-32.6c19.67-20.9 30.38-44.88 36.98-65.14 6.59-20.26-16.19-78.82-22.61-98.81-8.63-26.85-32.76-66.7-42.18-76.7Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1671.63 486.73s-4.45 2.34-7.89 3.63c-3.44 1.29-8.69 2.14-18.59.42-9.9-1.72-35.6-1.28-35.6-1.28l8.6 54.19s11.61-2.59 21.07-5.59c9.46-3.02 24.09-11.61 27.96-16.35 3.87-4.74 15.48-7.74 15.48-7.74l-11.03-27.29ZM1487.86 466.46l-20.26 11.97s6.92 15.15 14.28 22.51 19.92 18.61 19.92 18.61l21.64-46.32s-16.88-3.47-23.81-4.76c-6.92-1.31-11.77-2.01-11.77-2.01Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="m1629.6 445.54-100.4-8.48-43.36 79.65-4.24 28.28s35.36 12.26 82.96 21.68c47.6 9.44 96.15 1.89 96.15 1.89l-.94-19.32s-7.07-11.31-16.02-33.94c-8.95-22.63-14.13-69.75-14.13-69.75Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1602.36 217.22c8.43-9.12 13.38-10.38 20.81-27.32 6.29-14.33 4.75-26.83.62-40.65-2.35-7.87-7.4-9.27-7.4-9.27l-79.84 14.08s-.97 3.72-.25 12.77c1.27 15.88 3.03 24.94 15.08 37.01 5.4 5.4 16.57 14.53 27.95 18.67 4.82 1.75 17.93.22 23.02-5.28Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-e)',
        }}
      >
        <path
          d="M1588.62 138.92s10.94-5.13 16.01-4.28c3.11.52 10.14 1.09 10.14 1.09l.76-4.16s-2.57-.73-10.87-2.91c-5.94-1.55-17.12 4.65-17.12 4.65-.47-.32 1.07 5.61 1.07 5.61ZM1563.98 134.69c.21-.53 2.54 5.32 2.54 5.32s-11.18 3.75-15.18 4.45c-3.51.61-10.27 8.58-10.27 8.58l-3.79-3.1s5.11-7.84 11.1-10.52c6-2.69 15.6-4.75 15.6-4.75Z"
          style={{
            fill: '#1c3628',
          }}
        />
      </g>
      <path
        d="M1572.29 196.21c-.55-2.72 2.78-7 5.98-7.86 3.37-.91 3.9-.19 4.95-.32 1.59-.21 2.14-1.33 5.12-1.42 4.71-.14 8.23 3.37 8.63 5.72.77 4.55-4.13 10.88-10.6 12.15-6.68 1.31-13.19-3.88-14.07-8.27Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <path
        d="M1602.63 144.33c-2.39-1.33-4.92.01-5.74 1.73-1.14 2.42-.98 4.9 1.55 6.1 2.14 1.02 4.56.35 5.92-1.86 1.34-2.21.58-4.67-1.73-5.97Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1594.72 146.33 8.28-.95 8.81 1.12 1.68-4.6-4.38-2.06-14.84 2.86.45 3.63zM1555.24 153.98c1.6-2.21 4.49-2.06 5.94-.86 2.06 1.7 2.96 4.02 1.17 6.18-1.52 1.83-3.99 2.25-6.15.81s-2.51-4-.96-6.14Z"
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1563.5 152.14-8.08 3.39-8.6 4.65-1.52-3.98 4.32-4.86 12.14-1.92 1.74 2.72z"
      />
    </svg>
  )
}

export default MumAfter